var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_8304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2523 6.21523L16.25 5.26183V5.05273H12.7943L10.3318 11.1811L7.53068 5.05273H3.90795V5.26183L5.07273 6.6641C5.12833 6.71548 5.17123 6.77907 5.19805 6.84987C5.22487 6.92067 5.23488 6.99673 5.22727 7.07205V12.5834C5.24466 12.6815 5.23848 12.7823 5.20924 12.8776C5.18 12.9728 5.12853 13.0597 5.05909 13.1311L3.75 14.7209V14.9277H7.47159V14.7186L6.15909 13.1277C6.08893 13.0564 6.03613 12.97 6.0048 12.875C5.97346 12.78 5.96443 12.679 5.97841 12.58V7.81637L9.24432 14.93H9.625L12.433 7.81637V13.4834C12.433 13.6323 12.433 13.663 12.3352 13.7618L11.325 14.7391V14.9482H16.2273V14.7391L15.2534 13.7857C15.2109 13.754 15.1779 13.7114 15.1578 13.6623C15.1378 13.6132 15.1316 13.5596 15.1398 13.5073V6.49364C15.1314 6.44128 15.1376 6.38764 15.1577 6.33854C15.1777 6.28945 15.2108 6.2468 15.2534 6.21523H15.2523Z",
    fill: "#1D1F25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_8304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.179cc58535d3bdce72e4557decbcb479.svg";
export { ForwardRef as ReactComponent };